import React, { useCallback } from 'react'
import {
  ViewBody,
} from 'components/Sidebar'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
} from 'react-bootstrap'
import { FieldHookConfig, useField } from 'formik'
import { ListItem } from 'components/List'
import styled from 'styled-components'
import SelectUser from './SelectUser'
import User from 'components/ControlledUser'
import KanBoIcon from 'components/KanBoIcon'
import { useBoardContext } from 'dataProviders/Board'
import { useCardContext } from 'dataProviders/Card'
import { ModalBoardContext, ModalCardContext } from 'components/Modal'

const None = styled.span`
  opacity: 0.5;
`

type Props = LeftSidebarProps & FieldHookConfig<number | undefined>

const UserField: React.FC<Props> = ({
  leftSidebar,
  ...props
}) => {
  const boardContext = useBoardContext()
  const cardContext = useCardContext()

  const [field, meta, helpers] = useField(props)

  const showSelectUser = useCallback((setValue) => {
    leftSidebar.push(() => (
      <ModalBoardContext boardId={boardContext.id}>
        <ModalCardContext cardId={cardContext.id}>
          <SelectUser
            onSelect={userId => {
              setValue(userId)

              leftSidebar.pop()
            }}
          /> 
        </ModalCardContext>
      </ModalBoardContext>
    ))
  }, [leftSidebar])

  return (
    <FormGroup>
      <ViewBody>
        <ControlLabel><FormattedMessage id='BLOCKERS_CARD_BLOCK_USER' /></ControlLabel>
      </ViewBody>
      {meta.value
        ? (
          <User
            id={meta.value}
            listItem
            defaultMenu
            menu={[{
              icon: <KanBoIcon fixedWidth name='kanbo-16-remove-responsible' />,
              title: <FormattedMessage id='REMOVE' />,
              onClick: () => {
                helpers.setValue(undefined)
              }
            }]}
            onClick={() => showSelectUser(helpers.setValue)}
          />
        ) : (
          <ListItem onClick={() => showSelectUser(helpers.setValue)}>
            <None><FormattedMessage id='BLOCKERS_CARD_BLOCK_USER_SELECT_NONE' /></None>
          </ListItem>
        )
      }
    </FormGroup>
  )
}

export default withLeftSidebar(UserField)
